module.exports = __webpack_public_path__ + "65022dccc0cb5d349c9bacf0905a41e7.pdf";